import React from 'react';
import _ from 'lodash';

import {
  HistoryCredibilitySlice,
  type HistoryCredibilitySliceProps,
} from '@ww-digital/web-palette-react/dist/components/Slice/HistoryCredibilitySlice/HistoryCredibilitySlice';

import { JSONLD } from '../../Metadata/JSONLD/JSONLD.tsx';

type JSONLDType = {
  '@type': 'History';
  name: 'History';
  author: {
    '@type': 'Organization';
    name: string;
    jobTitle?: string;
  };
};

interface HistoryCredibilitySliceContainerProps {
  slice: HistoryCredibilitySliceProps;
  daCategory: string;
}

export const HistoryCredibilitySliceContainer = ({
  slice,
}: HistoryCredibilitySliceContainerProps): JSX.Element => {
  const getJSONLD = () => {
    const dataLD: JSONLDType = {
      '@type': 'History',
      name: 'History',
      author: {
        '@type': 'Organization',
        name: 'WeightWatchers',
      },
    };

    const data = {
      '@context': 'https://schema.org',
      '@type': 'HistoryCredibilitySlice',
      mainEntity: dataLD,
    };

    return data;
  };

  const jsonLD = getJSONLD();

  return (
    <>
      <JSONLD key="jsonLd" content={jsonLD} addWebsiteName={false} />
      <HistoryCredibilitySlice {...slice} />
    </>
  );
};
